import {
    PLANO_CONTA_MODO_TELA,
    PLANO_CONTA_SET_AGUARDANDO,
    PLANO_CONTA_LISTADO
} from './planoContaActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (
    state = INITIAL_STATE,
    action
) => {
    switch (action.type) {
        case PLANO_CONTA_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro:
                    action.payload.registro || {}
            };

        case PLANO_CONTA_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case PLANO_CONTA_LISTADO: {
            const lista =
                action.payload.data || [];

            return {
                ...state,
                lista,

                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: `${item.codigo} - ${item.nome}`
                }))
            };
        }

        default:
            return state;
    }
};